<template>
    <div class="container elegant contact">
        <div class="row">
            <div class="col-lg-10 col-lg-offset-1">
                <div class="card">
                    <div class="row">
                        <div class="col-md-7"
                            style="border-right: 1px; border-right-color: #EEE; border-right-style: solid;">
                            <form @submit.prevent="handleSubmit" class="form-horizontal" role="form">
                                <div class="form-group">
                                    <h2 class="diet">Contact</h2>
                                    <p>Got a question? Get in touch with us!</p>
                                    <p>Need an answer now?
                                        <router-link to="/faq">Check our FAQ</router-link>
                                    </p>
                                </div>

                                <div class="form-group">
                                    <label for="name" class="control-label sr-only">Name</label>
                                    <input v-model="formData.name" class="form-control required"
                                        placeholder="Name" type="text" autocomplete="off">
                                </div>

                                <div class="form-group">
                                    <label for="email" class="control-label sr-only">Email</label>
                                    <input v-model="formData.email" class="form-control email required"
                                        placeholder="Email" type="email" autocomplete="off">
                                </div>

                                <div class="form-group">
                                    <label for="subject" class="control-label sr-only">Subject</label>
                                    <input v-model="formData.subject" class="form-control required"
                                        placeholder="Subject" type="text" autocomplete="off">
                                </div>

                                <div class="form-group">
                                    <label for="message" class="control-label sr-only">Message</label>
                                    <textarea v-model="formData.info" class="form-control required"
                                        placeholder="How can we help?" rows="5" autocomplete="off"></textarea>
                                </div>

                                <div class="form-group">
                                    <button type="submit" class="btn btn-primary pull-right" :disabled="submitting">
                                        <i class="icon fa fa-send"></i>
                                        {{ submitting ? 'Sending...' : 'Send' }}
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div class="col-md-5 text-center">
                            <h4 class="upper">
                                <small>Address</small>
                            </h4>
                            <p>{{ aboutContent }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { commonApi } from '@/api'

export default {
    name: 'Contact',
    data() {
        return {
            formData: {
                name: '',
                email: '',
                subject: '',
                info: ''
            },
            submitting: false,
            aboutContent:""
        }
    },
    mounted(){
        this.loadAboutContent();
    },
    methods: {
        async loadAboutContent() {
            try {
                this.loading = true
                const response = await commonApi.getConfig()

                console.log('配置数据响应:', response)

                if (response.code === 1 && response.data) {
                    this.aboutContent = response.data.address || ''
                    console.log('关于我们内容:', this.address)
                } else {
                    this.$toast('Load failed', 3000)
                }
            } catch (error) {
                console.error('Failed to load about content:', error)
                this.$toast('Load failed, please try again', 3000)
            } finally {
                this.loading = false
            }
        },
        async handleSubmit() {
            // 验证表单
            if (!this.formData.name || !this.formData.email || !this.formData.subject || !this.formData.info) {
                this.$toast('Please fill in all fields', 3000)
                return
            }

            // 验证邮箱格式
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.formData.email)) {
                this.$toast('Please enter a valid email address', 3000)
                return
            }

            try {
                this.submitting = true

                const formData = new FormData()
                formData.append('name', this.formData.name)
                formData.append('email', this.formData.email)
                formData.append('subject', this.formData.subject)
                formData.append('info', this.formData.info)

                const response = await commonApi.contactUs(formData)

                console.log('联系我们响应:', response)

                if (response.code === 1) {
                    this.$toast('Message sent successfully! We will get back to you soon.', 3000)

                    // 清空表单
                    this.formData = {
                        name: '',
                        email: '',
                        subject: '',
                        info: ''
                    }
                } else {
                    this.$toast(response.msg || 'Failed to send message', 3000)
                }
            } catch (error) {
                console.error('Failed to send message:', error)
                this.$toast('Failed to send message, please try again', 3000)
            } finally {
                this.submitting = false
            }
        }
    }
}
</script>

<style scoped>
.btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* 移动端适配 */
@media (max-width: 767px) {
    .container.contact {
        padding-bottom: 80px;
    }
}
</style>